import { useSyncExternalStore } from "react";

/**
 * "Windows & tiling", per device (localStorage; absent = on). Off, a desktop gets the
 * tab layout a tablet or phone has — one view at a time, no splits. The stored
 * workspace is left alone, so turning it back on restores the windows.
 */
export const WINDOWS_PREF_KEY = "automation.windows";

const listeners = new Set<() => void>();

export function readWindowsPref(storage: Pick<Storage, "getItem"> | undefined): boolean {
  try {
    return storage?.getItem(WINDOWS_PREF_KEY) !== "0";
  } catch {
    return true;
  }
}

const read = () => readWindowsPref(typeof localStorage === "undefined" ? undefined : localStorage);

export function setWindowsPref(value: boolean): void {
  try {
    localStorage.setItem(WINDOWS_PREF_KEY, value ? "1" : "0");
  } catch {
    // Private mode: holds only until reload.
  }
  listeners.forEach((l) => l());
}

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === WINDOWS_PREF_KEY) listeners.forEach((l) => l());
  });
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => void listeners.delete(listener);
};

export function useWindowsPref(): [boolean, (value: boolean) => void] {
  return [useSyncExternalStore(subscribe, read), setWindowsPref];
}
